export default {
    general: {
        GENERAL_ERROR:
            'Doslo je do greške. Molimo vas pokušajte ponovo. Ukoliko se greška ponavlja, kontaktirajte podršku',
    },
    auth: {
        WRONG_PASSWORD: 'Uneli ste pogrešnu lozinku',
        COMPANY_NOT_ASSIGNED: 'Nalog nema kompaniju. Kontaktirajte admina',
    },
    accounts: {
        ACCOUNT_NOT_FOUND: 'Nalog nije pronađen',
        ACCOUNT_ALREADY_EXIST: 'Nalog sa unetim email-om već postoji',
        COMPANY_OWNER_ALREADY_ASSIGNED: 'Vlasnik kompanije dodeljen drugoj kompaniji. Pokusajte sa drugim vlasnikom!',
    },
    terminal: {
        TERMINAL_ALREADY_ASSIGNED: 'Terminal je već povezan',
        DEVICE_ID_ALREADY_EXIST: 'Terminal sa ID-ijem uređaja već postoji',
    },
    company: {
        COMPANY_ALREADY_EXISTS: 'Kompanija sa istim VAT ili ID brojem već postoji',
    },
    document: {
        SIZE_LIMIT: 'Fajl mora biti maksimalno 5MB',
        FILE_MISSING: 'Nedostaje dokument',
    },
    companyOwner: {
        PHONE_NUMBER_ALREADY_ASSIGNED: 'Broj telefona je već dodeljen drugom vlasniku',
    },
    website: {
        WEBSITE_ALREADY_EXISTS: 'Website sa unetim domenom već postoji',
    },
    products: {
        PRODUCT_ALREADY_EXISTS: 'Proizvod sa zadatim imenom već postoji',
        PRODUCT_DISCOUNTED_PRICE_GREATER_THAN_PRICE: 'Snižena cena ne sme biti jednaka ili veća od cene',
    },
    nestedProducts: {
        NESTED_PRODUCT_ALREADY_EXISTS: 'Prilog sa zadatim imenom već postoji',
        NESTED_PRODUCT_DISCOUNTED_PRICE_GREATER_THAN_PRICE: 'Snižena cena ne sme biti jednaka ili veća od cene',
    },
    productCategories: {
        PRODUCT_CATEGORY_ALREADY_EXISTS: 'Kategorija proizvoda sa zadatim imenom već postoji',
    },
    nestedProductCategories: {
        NESTED_PRODUCT_CATEGORY_ALREADY_EXISTS: 'Kategorija priloga/dodatka sa zadatim imenom već postoji',
    },
    promotion: {
        PROMOTION_CATEGORY_ALREADY_EXISTS: 'Promocija sa zadatim imenom već postoji',
        DISCOUNTED_PROMOTION_SHOULD_HAVE_DATE_RAGE: 'Snižena promocija mora imati datum početka i završetka',
        DISCOUNTED_PROMOTION_CANNOT_START_IN_PAST: 'Snižena promocija ne može početi u prošlosti',
        PRODUCT_ALREADY_IN_PROMOTION: 'Jedan ili više proizvoda se već nalaze na promociji',
    },
    place: {
        SLUG_ALREDY_EXISTS: 'Lokal sa unetom adresom već postoji',
        NAME_IN_USE: 'Lokal sa zadatim imenom već postoji',
    },
};
